import React from "react";
import { Dialog } from "@progress/kendo-react-dialogs";
import {
    SimpleLoading,
    InstructionsPure,
    ButtonHLPure,
} from "../../../pures";
import './renovation-dialog.css'


const RenovationDialog = (
    {
        loadingComponent,
        cancel,
        saveError,
        title,
        description,
        handleSubmitProfile,
        saveBtn,
        canelBtn,
        profiles,
        userId,
        userName,
        children,
        width,
        height,
        heightBody,
        bottomChildren,
        bottomChildrenStyles
    }
) => {

    return (
        <Dialog
            width={width}
            height={height}
            title={title}
            onClose={cancel}
        >
            {loadingComponent && (
                <div>
                    <SimpleLoading />
                </div>
            )}

            {!saveError && !loadingComponent && (
                <form>
                    <div className="dialogRenovation-body-dialog">
                        <InstructionsPure instructions={[description]} />
                        <div className="dialogRenovation-container-children" style={{ height: `${heightBody}px` }}>
                            {children}
                        </div>
                        <div
                            item="true"
                            xs={12}
                            lg={12}
                            md={12}
                            sm={12}
                            es={12}
                            className="dialogRenovation-btns-container"
                        >
                            {bottomChildren &&
                                <div className={bottomChildrenStyles}>
                                    {bottomChildren}
                                </div>
                            }
                            <div style={
                                {
                                    display: "flex",
                                    justifyContent: "end",
                                    alignItems: "center",
                                }}>
                                <div className="dialogRenovation-btn-cancel">
                                    <ButtonHLPure
                                        nameBtn={canelBtn}
                                        primary={false}
                                        onClickBtn={cancel}
                                    />
                                </div>

                                {
                                    handleSubmitProfile &&
                                    <div>
                                        <ButtonHLPure
                                            nameBtn={saveBtn}
                                            primary={true}
                                            onClickBtn={(e) => handleSubmitProfile(e)}
                                        />
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </form>
            )}
        </Dialog>
    );
};

export { RenovationDialog as default };
